import { formatBulletList } from './utils';

/**
 * Format LinkedIn post data for copying as Markdown
 */
export const formatLinkedInCopy = (data: any): string => {
  if (!data || !data.posts) {
    return 'No LinkedIn content available';
  }

  const posts = data.posts.map((post: any, index: number) => {
    const sections: string[] = [];

    // Add post number if multiple posts
    if (data.posts.length > 1) {
      sections.push(`## Post ${index + 1} of ${data.posts.length}`);
      sections.push('');
    }

    // Main content
    sections.push(post.content);
    sections.push('');

    // Hashtags
    if (post.hashtags && post.hashtags.length > 0) {
      sections.push(post.hashtags.map((tag: string) => `${tag}`).join(' '));
      sections.push('');
    }

    // Call to Action
    if (post.call_to_action) {
      sections.push(`**CTA:** ${post.call_to_action}`);
    }

    // Tone
    if (post.tone) {
      sections.push(`**Tone:** ${post.tone}`);
    }

    // Engagement Hooks
    if (post.engagement_hooks && post.engagement_hooks.length > 0) {
      sections.push('');
      sections.push('**Engagement Hooks:**');
      sections.push(formatBulletList(post.engagement_hooks));
    }

    return sections.join('\n');
  });

  return posts.join('\n\n---\n\n');
};
